

























import NavBar from '@/components/NavBar.vue'
import SideBar from '@/components/SideBar.vue'
import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'

@Component({
  components: {
    NavBar,
    SideBar,
  },
})
export default class App extends Vue {
  get isLoggedIn(): boolean {
    return store.getters.isLoggedIn
  }

  displayResponsiveSidebar = false

  mounted() {
    this.setResponsiveSidebarVisibility()
    window.addEventListener('resize', this.setResponsiveSidebarVisibility)
  }

  setResponsiveSidebarVisibility() {
    this.displayResponsiveSidebar = window.innerWidth < 576
  }
}

